import userRepository from '../../backend/userRepository'
import { OK, UNAUTHORIZED } from '../../utils/const'
import { removeToken, setToken, getToken } from '../../utils/auth'


const state = {
    user: null,
    role: null,
    apiStatus: null,
    isValid: null,
    messageByKey: null,
    errorMessage: null,
    authKey: null,
    isLoggedIn: !! getToken()
}

const getters = {
    getApiStatus: state => !! state.apiStatus,
    getRole: state => state.role
}

const mutations = {
    setUser(state, user) {
        state.user = user
    },
    setRole(state, role) {
        state.role = role
    },
    setApiStatus(state, status) {
        state.apiStatus = status
    },
    setIsLoggedIn(state, isLoggedIn) {
        state.isLoggedIn = isLoggedIn
    },
    setIsValid(state, isValid) {
        state.isValid = isValid
    },
    setMessageByKey(state, message) {
        state.messageByKey = message
    },
    setErrorMessage(state, message) {
        state.errorMessage = message
    },
    setAuthKey(state, key) {
        state.authKey = key
    }
}

const actions = {

    // キー認証
    async certifyAuhtKey(context, key) {
        context.commit('setMessageByKey', null)
        context.commit('setApiStatus', null)
        context.commit('setIsValid', null)

        // 通信
        const response = await userRepository.certifyAuhtKey(key)

        // 正常
        if (response.status === OK) {
            context.commit('setApiStatus', true)
            context.commit('setIsValid', true)
            document.cookie = "authKey=" + key;
            return
        }

        // 認証エラー
        if (response.status === UNAUTHORIZED) {
            context.commit('setApiStatus', false)
            context.commit('setMessageByKey', '不正なキーです')
            return
        }

        // システムエラー
        context.commit('setApiStatus', false)
        context.commit('setMessageByKey', 'システムエラーです')
    },

    // Eメールログイン
    async loginByEmail(context, profile) {
        context.commit('setApiStatus', null)
        context.commit('setErrorMessage', null)

        const response = await userRepository.loginByEmail(profile)

        if (response.status === OK) {
            const accessToken = response.data.data.access_token

            context.commit('setApiStatus', true)
            context.commit('setIsLoggedIn', true)
            setToken(accessToken)
            return
        }

        context.commit('setApiStatus', false)
        context.commit('setErrorMessage', 'ログインに失敗しました')
        context.commit('setIsLoggedIn', false)

    },
    // Oauth認証ログイン
    async loginByOauth(context, profile) {
        context.commit('setApiStatus', null)
        context.commit('setErrorMessage', null)

        const response = await userRepository.loginByOauth(profile)

        if (response.status === OK) {
            const accessToken = response.data.data.access_token

            context.commit('setApiStatus', true)
            context.commit('setIsLoggedIn', true)
            setToken(accessToken)
            return
        }

        context.commit('setApiStatus', false)
        context.commit('setErrorMessage', 'ログインに失敗しました')
        context.commit('setIsLoggedIn', false)
    },
    // 認証済みか確認
    async checkAuthed(context) {
        context.commit('setApiStatus', null)

        const response = await userRepository.getUser()

        if (response.status === OK) {
            const user = response.data
            const role = response.data.role

            context.commit('setApiStatus', true)
            context.commit('setRole', role)
            context.commit('setUser', user)
            context.commit('setIsLoggedIn', true)

            return
        }

        context.commit('setRole', null)
        context.commit('setApiStatus', false)
        context.commit('setUser', null)
        context.commit('setIsLoggedIn', false)
    },

    // 認証キーを閲覧できるか確認する
    async canViewSecret(context, token) {
        context.commit('setApiStatus', null)

        const response = await userRepository.fetchAuthKey(token);

        if (response.status === OK) {
            const key = response.data.key

            context.commit('setApiStatus', true)
            context.commit('setAuthKey', key)
            return
        }

        context.commit('setApiStatus', false)
        context.commit('setAuthKey', null)
    },

    // ログアウト
    async logout(context) {
        context.commit('setApiStatus', null)

        const response = await userRepository.logout()

        if (response.status === OK) {
            removeToken()
            context.commit('setRole', null)
            context.commit('setUser', null)
            context.commit('setIsLoggedIn', false)
            context.commit('setApiStatus', true)
            return
        }

        context.commit('setApiStatus', false)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}